import moment from 'moment';
import { defaultDateFormat } from 'Common/GeneralHelper';

import * as types from './types';

const INITIAL_STATE = {
  siteOptions: [],
  fetchError: '',
  pageLoading: false,
  tableLoading: false,
  deleted: false,
  fromDate: defaultDateFormat(moment().subtract(1, 'months')),
  toDate: defaultDateFormat(moment()),
  site: 'ALL',
  isSupper: false,
  exists: false,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.MODIFY_DAILY_DEPOSIT_GET_SITES:
      const options = [
        { text: 'ALL', value: 'ALL' },
        ...payload
          // .filter((site, index) => sites.findIndex(s => s.Id === site.Id) === index)
          .map(site => ({
            text: `${site.Id} ${site.Description}`,
            value: site.Id,
          })),
      ];
      return { ...state, siteOptions: options };
    case types.MODIFY_DAILY_DEPOSIT_GET_DATA:
      return { ...state, data: payload };
    case types.MODIFY_DAILY_DEPOSIT_FETCH_ERROR:
      return { ...state, fetchError: payload };
    case types.MODIFY_DAILY_DEPOSIT_FETCHING:
      return { ...state, pageLoading: payload };
    case types.MODIFY_DAILY_DEPOSIT_FETCHING_TABLE_DATA:
      return { ...state, tableLoading: payload };
    case types.MODIFY_DAILY_DEPOSIT_DELETED:
      return { ...state, deleted: payload };
    case types.MODIFY_DAILY_DEPOSIT_SET_FROM_DATE:
      return { ...state, fromDate: payload };
    case types.MODIFY_DAILY_DEPOSIT_SET_TO_DATE:
      return { ...state, toDate: payload };
    case types.MODIFY_DAILY_DEPOSIT_SET_SITE:
      return { ...state, site: payload };
    case types.MODIFY_DAILY_DEPOSIT_SET_ISSUPPER:
      return { ...state, isSupper: payload };
    case types.MODIFY_DAILY_DEPOSIT_EXISTS:
      return { ...state, exists: payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/modifydailydeposits/state/modifydailydepositgrid/reducer.js